import {
  SEARCH_GROUPS_LIST_PAGE_SUCCESS,
  SEARCH_GROUPS_LIST_PAGE_FAIL,
  SEARCH_GROUPS_LIST_PAGE_START,
  GROUPS_LIST_PAGE_DELETE_GROUPS_START,
  GROUPS_LIST_PAGE_DELETE_GROUPS_SUCCESS,
  GROUPS_LIST_PAGE_SET_LOADING,
  GROUP_ADDED_SUCCESS,
  GROUPS_LIST_PAGE_SEARCH_USERS,
  GROUPS_LIST_PAGE_SEARCH_USERS_START,
  GROUPS_LIST_PAGE_SEARCH_USERS_SUCCESS,
  GROUPS_LIST_PAGE_SEARCH_USERS_FAIL,
  GROUPS_LIST_PAGE_ACTIVE_USERS_FILTERS,
  GROUPS_LIST_PAGE_RESET_USER_FILTERS,
  GROUPS_LIST_PAGE_UPDATE_GROUP_FILTER,
  GROUPS_LIST_PAGE_HYDRATE_ACTIVE_USERS,
  GROUPS_LIST_PAGE_HYDRATE_ACTIVE_USERS_START,
  GROUPS_LIST_PAGE_HYDRATE_ACTIVE_USERS_SUCCESS,
  GROUPS_LIST_PAGE_HYDRATE_ACTIVE_USERS_FAIL,
} from 'actions/groupList';

import { getListPageSuccessNewData } from '../utils';

export const defaultState = {
  loading: true,
  data: [],
  dataLoaded: false,
  links: {},
  paging: false,
  error: false,
  groupsAdded: 0,
  users: {
    total: 0,
    data: [],
    loading: false,
    activeItems: [],
  },
};

export default function groupListPage(state = defaultState, action) {
  switch (action.type) {
    case GROUPS_LIST_PAGE_UPDATE_GROUP_FILTER: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case SEARCH_GROUPS_LIST_PAGE_START: {
      return {
        ...state,
        dataLoaded: false,
      };
    }
    case SEARCH_GROUPS_LIST_PAGE_SUCCESS: {
      const { data, links, total } = action.payload;
      return {
        ...state,
        data: getListPageSuccessNewData(state, data, links),
        dataLoaded: true,
        total,
        links,
        loading: false,
        error: false,
      };
    }
    case GROUPS_LIST_PAGE_SET_LOADING: {
      return {
        ...state,
        loading: true,
      };
    }
    case SEARCH_GROUPS_LIST_PAGE_FAIL: {
      return {
        ...state,
        loading: false,
        error: true,
      };
    }
    case GROUPS_LIST_PAGE_DELETE_GROUPS_START: {
      return {
        ...state,
        loading: true,
      };
    }
    case GROUPS_LIST_PAGE_DELETE_GROUPS_SUCCESS: {
      return {
        ...state,
        data: [], // Require reload
      };
    }
    case GROUP_ADDED_SUCCESS: {
      return {
        ...state,
        groupsAdded: state.groupsAdded + 1,
      };
    }

    case GROUPS_LIST_PAGE_HYDRATE_ACTIVE_USERS: {
      return state;
    }
    case GROUPS_LIST_PAGE_HYDRATE_ACTIVE_USERS_SUCCESS: {
      const { data } = action.payload;
      return {
        ...state,
        users: {
          ...state.users,
          data,
          loading: false,
        },
      };
    }
    case GROUPS_LIST_PAGE_HYDRATE_ACTIVE_USERS_START: {
      return {
        ...state,
        users: {
          ...state.users,
          loading: true,
        },
      };
    }
    case GROUPS_LIST_PAGE_HYDRATE_ACTIVE_USERS_FAIL: {
      return {
        ...state,
        users: {
          ...state.users,
          loading: false,
        },
      };
    }

    case GROUPS_LIST_PAGE_SEARCH_USERS: {
      return state;
    }
    case GROUPS_LIST_PAGE_SEARCH_USERS_SUCCESS: {
      const { data, total } = action.payload;
      return {
        ...state,
        users: {
          ...state.users,
          data,
          total,
          loading: false,
        },
      };
    }
    case GROUPS_LIST_PAGE_SEARCH_USERS_START: {
      return {
        ...state,
        users: {
          ...state.users,
          loading: true,
        },
      };
    }
    case GROUPS_LIST_PAGE_SEARCH_USERS_FAIL: {
      return {
        ...state,
        users: {
          ...state.users,
          loading: false,
        },
      };
    }
    case GROUPS_LIST_PAGE_ACTIVE_USERS_FILTERS: {
      const { payload } = action;
      const activeItems = [
        ...state.users.activeItems,
        ...payload.filter(
          item => !state.users.activeItems.find(a => a.id === item.id),
        ),
      ];
      return {
        ...state,
        users: {
          ...state.users,
          activeItems,
        },
      };
    }
    case GROUPS_LIST_PAGE_RESET_USER_FILTERS: {
      const { payload } = action;
      return {
        ...state,
        users: {
          ...state.users,
          data: [],
          total: 0,
          activeItems: payload,
        },
      };
    }
    case 'GROUPS_LIST_PAGE_PENDO_ERROR': {
      const { payload } = action;
      return {
        ...state,
        pendoErrorMessage: payload,
      };
    }
    case 'TOAST_REMOVE': {
      return {
        ...state,
        pendoErrorMessage: null,
      };
    }
    default:
      return state;
  }
}
